import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'projectStatus'
})
export class ProjectStatusPipe implements PipeTransform {

    transform(type: string, ...args: unknown[]): string {
        switch (type) {
            case 'created':
                return 'Idee eingelastet';
            case 'declined':
                return 'Idee verworfen';
            case 'line':
                return 'An Linie übergeben';
            case 'in_elaboration':
                return 'Projektauftrag in Ausarbeitung';
            case 'evaluation':
                return 'Projektauftrag in Prüfung';
            case 'cancelled':
                return 'Storniert';
            case 'revise':
                return 'Überarbeitung angefordert';
            case 'released':
                return 'Freigegeben';
            case 'in_progress':
                return 'In Arbeit';
            case 'completion_filed':
                return 'Projektabschluss eingereicht';
            case 'completed':
                return 'Projekt abgenommen';
            case 'on_hold':
                return 'On Hold';
            default:
                return type;
        }
    }
}
